<template>
  <fb-form-properties-manager id="eoc-active-medications-v1-properties-cn2gzy" :fields="fields" :formId="formId" />
</template>

<script>
export default {
  name: "EocActiveMedicationsV1Properties",
  props: ["formId"],
  data() {
    return {
      fields: [
        {
          type: "textInput",
          properties: {
            label: "Label"
          },
          property: "label"
        },
        {
          type: "textInput",
          properties: {
            label: "Description"
          },
          property: "description"
        },
        {
          type: "checkbox",
          properties: {
            label: "Exclude from Load From Last Result"
          },
          property: "excludeFromLoadFromLastResult"
        },
        {
          type: "checkbox",
          properties: {
            label: "Exclude from Paste content"
          },
          property: "excludeFromPasteContent"
        },
        {
          type: "dropdown",
          properties: {
            label: "Type",
            options: [
              {
                value: "both",
                text: "Both"
              },
              {
                value: "sch",
                text: "Sch"
              },
              {
                value: "prn",
                text: "Prn"
              }
            ]
          },
          property: "type"
        },
        {
          type: "conditionEditor",
          properties: {
            label: "Visibility condition",
            updateValueMiddleware: (value) => {return value.replace("{{(","{{!(")}
          },
          property: "hidden"   
        }
      ]
    };
  }
};
</script>

<style></style>
